function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
/* eslint-disable @typescript-eslint/no-use-before-define */ import * as React from 'react';
import PropTypes from 'prop-types';
import composeClasses from '@mui/utils/composeClasses';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import { gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector } from "../../hooks/features/columns/gridColumnsSelector.js";
import { useGridSelector } from "../../hooks/utils/useGridSelector.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { useLazyRef } from "../../hooks/utils/useLazyRef.js";
import { checkColumnVisibilityModelsSame, defaultSearchPredicate } from "./utils.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var collator = new Intl.Collator();
function GridColumnsManagement(props) {
    var _rootProps_slotProps, _rootProps_slotProps1, _rootProps_slotProps2, _rootProps_slotProps3;
    var apiRef = useGridApiContext();
    var searchInputRef = React.useRef(null);
    var columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
    var initialColumnVisibilityModel = useLazyRef(function() {
        return gridColumnVisibilityModelSelector(apiRef);
    }).current;
    var columnVisibilityModel = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
    var rootProps = useGridRootProps();
    var _React_useState = _sliced_to_array(React.useState(''), 2), searchValue = _React_useState[0], setSearchValue = _React_useState[1];
    var classes = useUtilityClasses(rootProps);
    var sort = props.sort, _props_searchPredicate = props.searchPredicate, searchPredicate = _props_searchPredicate === void 0 ? defaultSearchPredicate : _props_searchPredicate, _props_autoFocusSearchField = props.autoFocusSearchField, autoFocusSearchField = _props_autoFocusSearchField === void 0 ? true : _props_autoFocusSearchField, _props_disableShowHideToggle = props.disableShowHideToggle, disableShowHideToggle = _props_disableShowHideToggle === void 0 ? false : _props_disableShowHideToggle, _props_disableResetButton = props.disableResetButton, disableResetButton = _props_disableResetButton === void 0 ? false : _props_disableResetButton, _props_toggleAllMode = props.toggleAllMode, toggleAllMode = _props_toggleAllMode === void 0 ? 'all' : _props_toggleAllMode, getTogglableColumns = props.getTogglableColumns, searchInputProps = props.searchInputProps;
    var isResetDisabled = React.useMemo(function() {
        return checkColumnVisibilityModelsSame(columnVisibilityModel, initialColumnVisibilityModel);
    }, [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    var sortedColumns = React.useMemo(function() {
        switch(sort){
            case 'asc':
                return _to_consumable_array(columns).sort(function(a, b) {
                    return collator.compare(a.headerName || a.field, b.headerName || b.field);
                });
            case 'desc':
                return _to_consumable_array(columns).sort(function(a, b) {
                    return -collator.compare(a.headerName || a.field, b.headerName || b.field);
                });
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    var toggleColumn = function(event) {
        var _event_target = event.target, field = _event_target.name;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    var currentColumns = React.useMemo(function() {
        var togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        var togglableSortedColumns = togglableColumns ? sortedColumns.filter(function(param) {
            var field = param.field;
            return togglableColumns.includes(field);
        }) : sortedColumns;
        if (!searchValue) {
            return togglableSortedColumns;
        }
        return togglableSortedColumns.filter(function(column) {
            return searchPredicate(column, searchValue.toLowerCase());
        });
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    var toggleAllColumns = React.useCallback(function(isVisible) {
        var currentModel = gridColumnVisibilityModelSelector(apiRef);
        var newModel = _extends({}, currentModel);
        var togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach(function(col) {
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) {
                    // delete the key from the model instead of setting it to `true`
                    delete newModel[col.field];
                } else {
                    newModel[col.field] = false;
                }
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    var handleSearchValueChange = React.useCallback(function(event) {
        setSearchValue(event.target.value);
    }, []);
    var hideableColumns = React.useMemo(function() {
        return currentColumns.filter(function(col) {
            return col.hideable;
        });
    }, [
        currentColumns
    ]);
    var allHideableColumnsVisible = React.useMemo(function() {
        return hideableColumns.every(function(column) {
            return columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false;
        });
    }, [
        columnVisibilityModel,
        hideableColumns
    ]);
    var allHideableColumnsHidden = React.useMemo(function() {
        return hideableColumns.every(function(column) {
            return columnVisibilityModel[column.field] === false;
        });
    }, [
        columnVisibilityModel,
        hideableColumns
    ]);
    var firstSwitchRef = React.useRef(null);
    React.useEffect(function() {
        if (autoFocusSearchField) {
            searchInputRef.current.focus();
        } else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') {
            firstSwitchRef.current.focus();
        }
    }, [
        autoFocusSearchField
    ]);
    var firstHideableColumnFound = false;
    var isFirstHideableColumn = function(column) {
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    var handleSearchReset = React.useCallback(function() {
        setSearchValue('');
        searchInputRef.current.focus();
    }, []);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ _jsx(SearchInput, _extends({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "outlined",
                    size: "small",
                    type: "search",
                    InputProps: {
                        startAdornment: /*#__PURE__*/ _jsx(rootProps.slots.baseInputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ _jsx(rootProps.slots.quickFilterIcon, {})
                        }),
                        endAdornment: /*#__PURE__*/ _jsx(rootProps.slots.baseIconButton, _extends({
                            "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                            size: "small",
                            sx: [
                                searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                }
                            ],
                            tabIndex: -1,
                            onClick: handleSearchReset
                        }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseIconButton, {
                            children: /*#__PURE__*/ _jsx(rootProps.slots.quickFilterClearIcon, {
                                fontSize: "small"
                            })
                        }))
                    },
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, (_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ _jsxs(GridColumnsManagementBody, {
                className: classes.root,
                ownerState: rootProps,
                children: [
                    currentColumns.map(function(column) {
                        var _rootProps_slotProps;
                        return /*#__PURE__*/ _jsx(FormControlLabel, {
                            className: classes.row,
                            control: /*#__PURE__*/ _jsx(rootProps.slots.baseCheckbox, _extends({
                                disabled: column.hideable === false,
                                checked: columnVisibilityModel[column.field] !== false,
                                onClick: toggleColumn,
                                name: column.field,
                                sx: {
                                    p: 0.5
                                },
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                            }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseCheckbox)),
                            label: column.headerName || column.field
                        }, column.field);
                    }),
                    currentColumns.length === 0 && /*#__PURE__*/ _jsx(GridColumnsManagementEmptyText, {
                        ownerState: rootProps,
                        children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                    })
                ]
            }),
            (!disableShowHideToggle || !disableResetButton) && currentColumns.length > 0 ? /*#__PURE__*/ _jsxs(GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ _jsx(FormControlLabel, {
                        control: /*#__PURE__*/ _jsx(rootProps.slots.baseCheckbox, _extends({
                            disabled: hideableColumns.length === 0,
                            checked: allHideableColumnsVisible,
                            indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                            onClick: function() {
                                return toggleAllColumns(!allHideableColumnsVisible);
                            },
                            name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                            sx: {
                                p: 0.5
                            }
                        }, (_rootProps_slotProps2 = rootProps.slotProps) === null || _rootProps_slotProps2 === void 0 ? void 0 : _rootProps_slotProps2.baseCheckbox)),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText')
                    }) : /*#__PURE__*/ _jsx("span", {}),
                    !disableResetButton ? /*#__PURE__*/ _jsx(rootProps.slots.baseButton, _extends({
                        onClick: function() {
                            return apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel);
                        },
                        disabled: isResetDisabled
                    }, (_rootProps_slotProps3 = rootProps.slotProps) === null || _rootProps_slotProps3 === void 0 ? void 0 : _rootProps_slotProps3.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
process.env.NODE_ENV !== "production" ? GridColumnsManagement.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */ autoFocusSearchField: PropTypes.bool,
    /**
   * If `true`, the `Reset` button will not be disabled
   * @default false
   */ disableResetButton: PropTypes.bool,
    /**
   * If `true`, the `Show/Hide all` toggle checkbox will not be displayed.
   * @default false
   */ disableShowHideToggle: PropTypes.bool,
    /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */ getTogglableColumns: PropTypes.func,
    searchInputProps: PropTypes.object,
    searchPredicate: PropTypes.func,
    sort: PropTypes.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Changes the behavior of the `Show/Hide All` toggle when the search field is used:
   * - `all`: Will toggle all columns.
   * - `filteredOnly`: Will only toggle columns that match the search criteria.
   * @default 'all'
   */ toggleAllMode: PropTypes.oneOf([
        'all',
        'filteredOnly'
    ])
} : void 0;
var GridColumnsManagementBody = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement',
    overridesResolver: function(props, styles) {
        return styles.columnsManagement;
    }
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0, 3, 1.5),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        flex: '1 1',
        maxHeight: 400,
        alignItems: 'flex-start'
    };
});
var GridColumnsManagementHeader = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader',
    overridesResolver: function(props, styles) {
        return styles.columnsManagementHeader;
    }
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(1.5, 3)
    };
});
var SearchInput = styled(TextField, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput',
    overridesResolver: function(props, styles) {
        return styles.columnsManagementSearchInput;
    }
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, _define_property(_obj, "& .".concat(inputBaseClasses.root), {
        padding: theme.spacing(0, 1.5, 0, 1.5)
    }), _define_property(_obj, "& .".concat(inputBaseClasses.input, "::-webkit-search-decoration,\n  & .").concat(inputBaseClasses.input, "::-webkit-search-cancel-button,\n  & .").concat(inputBaseClasses.input, "::-webkit-search-results-button,\n  & .").concat(inputBaseClasses.input, "::-webkit-search-results-decoration"), {
        /* clears the 'X' icon from Chrome */ display: 'none'
    }), _obj;
});
var GridColumnsManagementFooter = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter',
    overridesResolver: function(props, styles) {
        return styles.columnsManagementFooter;
    }
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5, 1, 0.5, 3),
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: "1px solid ".concat(theme.palette.divider)
    };
});
var GridColumnsManagementEmptyText = styled('div')(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5, 0),
        color: theme.palette.grey[500]
    };
});
export { GridColumnsManagement };
